// Meta Pixel con consenso esplicito. L'ID arriva dal build (REACT_APP_META_PIXEL_ID):
// senza ID non viene caricato niente e la barra consenso non compare.
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const CONSENT_KEY = "idm_mkt_consent"; // "yes" | "no"
let loaded = false;

export const pixelConfigured = () => Boolean(PIXEL_ID);

export function getConsent() {
  try { return window.localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

export function setConsent(value) {
  try { window.localStorage.setItem(CONSENT_KEY, value); } catch { /* storage bloccato */ }
}

export function loadPixel() {
  if (!PIXEL_ID || loaded || typeof window === "undefined") return false;
  loaded = true;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  return true;
}

export function track(event, params) {
  if (typeof window !== "undefined" && window.fbq) window.fbq("track", event, params || {});
}

// Carica il pixel solo se c'e' consenso e manda gli eventi richiesti.
export function trackWithConsent(events) {
  if (!pixelConfigured() || getConsent() !== "yes") return;
  loadPixel();
  events.forEach(([ev, params]) => track(ev, params));
}

// UTM: lette dalla query della landing, conservate per la pagina grazie.
const UTM_KEY = "idm_utm";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUtm(search) {
  const params = new URLSearchParams(search || "");
  const utm = {};
  UTM_KEYS.forEach((k) => { const v = params.get(k); if (v) utm[k] = v.slice(0, 100); });
  if (Object.keys(utm).length) {
    try { window.sessionStorage.setItem(UTM_KEY, JSON.stringify(utm)); } catch { /* ignore */ }
    return utm;
  }
  try { return JSON.parse(window.sessionStorage.getItem(UTM_KEY) || "{}"); } catch { return {}; }
}

export function getUtm() {
  try { return JSON.parse(window.sessionStorage.getItem(UTM_KEY) || "{}"); } catch { return {}; }
}
